import { render, staticRenderFns } from "./SimpleText.vue?vue&type=template&id=0ed817f6"
import script from "./SimpleText.vue?vue&type=script&lang=js"
export * from "./SimpleText.vue?vue&type=script&lang=js"
import style0 from "./SimpleText.vue?vue&type=style&index=0&id=0ed817f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports